import OncolensLogoWithText from '@/assets/OncolensLogoWithText.svg';
import { useQueryParameters } from '@/hooks/useQueryParameters';
import { Transition } from '@headlessui/react';
import React, { ReactElement } from 'react';
import { FaSpinner } from 'react-icons/fa';
import { NavLink } from 'react-router-dom';
import { useGetRequest } from '../api/getRequest';
import { useGetTemplates } from '../api/getTemplates';
import { useGetWorkflows } from "@/features/requests/api/getWorkflows";

// interface Props { }

export default function RequestComplete(): ReactElement {
  const requestId = useQueryParameters().get('requestId') || '';
  const { isLoading, data } = useGetRequest(requestId);
  const { isLoading: isTemplateListLoading, data: templateList } = useGetTemplates();
  const { data: workflowList } = useGetWorkflows();
  const workflow = workflowList?.find((workflow) => workflow.id === data?.workflowId);
  const template = templateList?.find((template) => template.workflowId === workflow?.id);

  const pageLoading = isLoading && isTemplateListLoading;

  return (
    <div>
      <Transition
        show={pageLoading}
        className="absolute top-0 left-0 flex items-center justify-center w-full h-32 bg-white divide-y divide-gray-200"
        enter="transition-opacity duration-200"
        enterFrom="opacity-100"
        enterTo="opacity-100"
        leave="transition-opacity duration-200"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <FaSpinner className="w-6 h-6 duration-300 animate-spin" />
      </Transition>
      <Transition
        appear={true}
        show={!pageLoading}
        className="bg-white divide-y divide-gray-200"
        enter="transition-opacity duration-300"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity duration-300"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <img
          className="w-auto h-16 mx-auto mt-32 mb-16"
          src={OncolensLogoWithText}
          alt="Oncolens Logo"
        />
        <div className="px-8 py-16 mx-auto bg-gray-300 w-128 rounded-xl">
          <h1 className="text-2xl text-center mb-11">Request successfully submitted!</h1>
          <p className="mb-4 text-center">
						Your request has been submitted to {template?.name} for review.
          </p>
          <p className="mb-4 text-center">
						The case will be reviewed. If there are any questions or additional information needed
						then someone will reach out to you.
          </p>
          <p className="mb-4 text-center">
						You can visit{' '}
            <NavLink to="/requests" className="underline">
							the queue
            </NavLink>{' '}
						to check the status of your request at any time.
          </p>
        </div>
      </Transition>
    </div>
  );
}
